import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import fab from "../assets/fab.jpeg";
import { Link } from 'react-router-dom'
import dstechno from '../assets/logos/dstechno.png'
import gst from '../assets/logos/gst.png'
import kctech from '../assets/logos/kctech.png'
import shinhan from '../assets/logos/shinhan.png'
import ssk from '../assets/logos/ssk.jpeg'
import synopex from '../assets/logos/synopex.png'

const Partners = () => {
    return (
        <div className="animate-fade">
            <Header />

            <div className="z-[-1] mt-[60px] lg:mt-auto relative">
                <img src={fab} className="w-[100vw] h-[400px] opacity-85 object-cover object-left-top top-0 left-[50%]" width="2254" height="1193" alt="Office building interior" />
                <h1 className="font-bold text-[white] text-[1.5em] lg:text-[2em] m-[2em] uppercase absolute right-[5%] top-[50%] lg:top-[35%] z-1">Grow your business with ALKOR</h1>
            </div>

            <div className="mt-[3em] mb-[2em] flex flex-col content-center">
                <h2 className="text-center text-[1.5em] lg:text-[2em] m-[1em]">Building Stronger Semiconductor Networks Together.</h2>
                <p className="text-grayish text-center mx-[2em] lg:mx-[15em] leading-[1.8em]">Our company specializes in delivering high-quality, cost-effective solutions for semiconductor manufacturing. With a focus on reliability and innovation, we aim to empower our customers with the tools and resources they need to stay ahead in a rapidly evolving industry. Whether you're looking to expand your reach, enhance your technology, or optimize your operations, we're committed to helping you succeed.</p>
                <hr className=" h-[1px] border-0 border-t-[1.5px] my-[2em] lg:my-[3em] border-slate mx-[3em] lg:mx-[15em]" />
                <p className="text-grayish text-center mx-[2em] lg:mx-[15em] leading-[1.8em]">At ALKOR, we are proud to work with a network of trusted partners who share our commitment to innovation, quality, and global growth. Together, we drive the semiconductor industry forward, pushing boundaries and creating new opportunities for success.</p>
            </div>

            <div className="relative z-100 landscape:w-3/4 landscape:m-auto">
                <div className="flex flex-col landscape:flex-row landscape:justify-evenly lg:flex-row justify-center mb-[5em] lg:justify-evenly items-center">
                    <figure className="w-1/2 lg:w-auto mb-[3em] lg:mb-0 md:mb-0">
                        <Link to="http://en.shinhandia.co.kr/"><img src={shinhan} width="220" height="63"
                            alt="Shinhan" className="w-[80%] lg:w-[90%]" /></Link>
                    </figure>

                    <figure className="w-1/2 lg:w-auto">
                        <Link to="https://synopexfilter.com/eng/">
                            <img src={synopex} width="295" height="117"
                                alt="Synopex" className="w-[80%] lg:w-[90%]" />
                        </Link>
                    </figure>

                    <figure className="w-1/2 lg:w-auto">
                        <Link to="http://dstechno.co.kr/?lang=en"><img src={dstechno} width="200"
                            height="200" alt="DSTechno" className="w-[80%] lg:w-[90%]" /></Link>
                    </figure>

                    <figure className="w-1/2 lg:w-auto">
                        <Link to="http://www.superchem.co.kr/"><img src={ssk} width="220" height="65"
                            alt="SSK" className="w-[80%] lg:w-[90%]" /></Link>
                    </figure>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Partners;




